import React from "react";
import { approach } from "../../mock";
import useReveal from "../../hooks/useReveal";

export default function Approach() {
  const ref = useReveal();

  return (
    <section className="approach" id="approach" ref={ref}>
      <div className="section-head" data-reveal>
        <h2 className="section-title">
          Подход
          <span className="annotation" style={{ color: "var(--ink-soft)" }}>
            (философия)
          </span>
        </h2>
        <span className="section-num">03.</span>
      </div>

      <div className="approach-body">
        <p className="approach-statement" data-reveal>
          „{approach.statement}“
        </p>
      </div>

      <div className="approach-grid" data-reveal>
        {approach.principles.map((p) => (
          <div className="approach-cell" key={p.index}>
            <span className="idx">{p.index}.</span>
            <h3>{p.title}</h3>
            <p>{p.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
